const initialState = {
  width: window.innerWidth || 0,
  height: window.innerHeight || 0,
};

const utilsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SCREEN_SIZE":
      return {
        ...state,
        width: action.payload.width,
        height: action.payload.height,
      };
    default:
      return state;
  }
};

export default utilsReducer;
